var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":"PatientCreateOrder"}},[_c('router-view',{attrs:{"patient":_vm.patient}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }